// covered-by: frontends/carrie/src/components/ask-puntt-review/__tests__/resolveReviewListCardThumbnail.test.ts
import { type AskPunttReview } from "@mg/schemas/src/christo/askPunttReview";

type ReviewFileLike = Pick<
  AskPunttReview["files"][number],
  "source" | "thumbnailUrl" | "type"
>;

export function normalizeThumbnailUrl(
  url: string | null | undefined,
): string | undefined {
  const trimmed = url?.trim();
  return trimmed ? trimmed : undefined;
}

/**
 * Pick a list-card thumbnail for Ask Puntt reviews.
 *
 * Demo enterprises may fall back to the full-res `source`; real tenants must
 * never use a PDF/video source as an `<img src>` — it renders as a broken icon.
 */
export function resolveReviewListCardThumbnail(input: {
  review?: Pick<AskPunttReview, "thumbnailUrl" | "files"> | null;
  payloadThumbnailUrl?: string | null;
  isDemoEnterprise?: boolean;
}): string | undefined {
  const review = input.review;
  const isDemo = input.isDemoEnterprise ?? false;

  const fromReview = normalizeThumbnailUrl(review?.thumbnailUrl);
  if (fromReview) return fromReview;

  for (const file of review?.files ?? []) {
    const thumb = normalizeThumbnailUrl(file.thumbnailUrl);
    if (thumb) return thumb;
  }

  const fromPayload = normalizeThumbnailUrl(input.payloadThumbnailUrl);
  if (fromPayload) return fromPayload;

  const firstFile: ReviewFileLike | undefined = review?.files?.[0];
  if (!firstFile) return undefined;

  if (isDemo) {
    return normalizeThumbnailUrl(firstFile.source);
  }

  if (firstFile.type === "image") {
    return normalizeThumbnailUrl(firstFile.source);
  }

  return undefined;
}
